import { useQuery } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';

/**
 * GET /api/eraf/terminology/standard-terms/:id
 * queryKey: ['terminology', 'standard-terms', 'detail', id]
 */
export function useStandardTerm(id: number | undefined) {
  return useQuery({
    queryKey: ['terminology', 'standard-terms', 'detail', id],
    queryFn: () => terminologyApi.getStandardTerm(id!),
    enabled: id !== undefined && id > 0,
    staleTime: 30_000,
  });
}
